import { connect } from 'react-redux';
import AdminPanelStockForm from './AdminPanelStockForm';

const mapStateToProps = (state) => {
  const auth =
    state.get('auth') && state.get('auth').toJS && state.get('auth').toJS();
  const kiosk = state.get('kiosk');
  return {
    ...auth,
    ...kiosk
  };
};

const AdminPanelStockFormContainer =
  connect(mapStateToProps)(AdminPanelStockForm);

export default AdminPanelStockFormContainer;
